import React from "react";
import viewsIcon from "assets/icons/views.svg";
import tvShowsIcon from "assets/icons/tvShowsIcon.svg";
import MovieViewsIcon from "assets/icons/viewsIcon.svg";

export default function CategoryViews({ category, number, views }) {
  return (
    <div className="tv-shows__overview justify-around ">
      <div className="tv-shows__card ">
        <div className="tv-shows__overview-card-title  ">
          <div className="tv-shows__overview-card-title-icon ">
            <img src={tvShowsIcon} alt="" />
          </div>
          <div className="tv-shows__overview-card-title-data">{category}</div>
        </div>
        <div className="tv-shows__overview-card-details">{number}</div>
        <div className="tv-shows__overview-color tv-shows-color"></div>
      </div>
      <div className="tv-shows__card card-views">
        <div className="tv-shows__overview-card-title">
          <div className="tv-shows__overview-card-title-icon">
            <img src={MovieViewsIcon} alt="" />
          </div>
          <div className="tv-shows__overview-card-title-data">Views</div>
        </div>
        <div className="tv-shows__overview-card-details">{views}</div>
        <div className="tv-shows__overview-color views"></div>
      </div>
    </div>
  );
}
